import { render, staticRenderFns } from "./TableTypeCustomFieldText.vue?vue&type=template&id=0ca132dc"
import script from "./TableTypeCustomFieldText.vue?vue&type=script&lang=js"
export * from "./TableTypeCustomFieldText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports